export const snackbarActionSelectors = {
  OPEN_SNACKBAR: "OPEN_SNACKBAR",
};
export const expensesActionSelectors = {
  GET_EXPENSES: "GET_EXPENSES",
  GET_EXPENSES_SUCCESS: "GET_EXPENSES_SUCCESS",
  GET_EXPENSES_TYPE: "GET_EXPENSES_TYPE",
  GET_EXPENSES_TYPE_SUCCESS: "GET_EXPENSES_TYPE_SUCCESS",
};
export const userActionSelectors = {
  GET_USER: "GET_USER",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",
  GET_USER_TYPES: "GET_USER_TYPES",
  GET_USER_TYPES_SUCCESS: "GET_USER_TYPES_SUCCESS",
};

export const authActionSelectors = {
  SET_USER_DATA: "SET_USER-_DATA",
  LOGOUT: "LOGOUT",
  LOGGED_IN_SUCCESS: "LOGGED_IN_SUCCESS",
};
export const paymentTypeActionSelectors = {
  GET_PAYMENT_TYPE: "GET_PAYMENT_TYPE",
};
export const bankActionSelectors = {
  GET_BANK: "GET_BANK",
};
export const stockLocationActionSelectors = {
  GET: "GET_STOCK_LOCATION",
};
export const pendingUserActionSelectors = {
  GET_PENDING_USER: "GET_PENDING_USER",
  GET_PENDING_USER_SUCCESS: "GET_PENDING_USER_SUCCESS",
};
export const activeUserActionSelectors = {
  GET_ACTIVE_USER: "GET_ACTIVE_USER",
  GET_ACTIVE_USER_SUCCESS: "GET_ACTIVE_USER_SUCCESS",
};
export const rejectUserActionSelectors = {
  GET_REJECT_USER: "GET_REJECT_USER",
  GET_REJECT_USER_SUCCESS: "GET_REJECT_USER_SUCCESS",
};
export const itemCategoryActionSelectors = {
  GET_ITEM_CATEGORY: "GET_ITEM_CATEGORY",
  GET_ITEM_CATEGORY_SUCCESS: "GET_ITEM_CATEGORY_SUCCESS",
};
export const expenseCategorySelectors = {
  GET_EXPASE_CATEGORY:"GET_EXPANSES_CATEGORY",
  GET_EXPANSES_CATEGOR_SUCCESS:"GET_EXPANSES_CATEGOR_SUCCESS"
}
export const batchNumberSelectors = {
  GET_BATCH_NUMBER: "GET_BATCH_NUMBER",
  GET_BATCH_NUMBER_SUCCESS: " GET_BATCH_NUMBER_SUCCESS",
};
export const binSelectors = {
  GET_BIN: "GET_BIN",
  GET_BIN_SUCCESS: "GET_BIN_SUCCESS",
};
export const colourSelectors = {
  GET_COLOUR: "GET_COLOUR",
  GET_COLOUR_SUCCESS: "GET_COLOUR_SUCCESS",
};
export const brandSelectors = {
  GET: "GET_BRAND",
  GET_SUCCESS: "GET_BRAND_SUCCESS",
};
export const unitSelectors = {
  GET: "GET_UNIT",
  GET_SUCCESS: "GET_UNIT_SUCCESS",
};
export const lastInsertInvoice = {
  GET: "GET_LAST_INSERT_INVOICE",
};
export const loginAuth = {
  IS_VALID: "SET_IS_VALID",
};
export const servicePack = {
  GET: "GET_SERVICE_PACK",
  GET_SUCCESS: "GET_SERVICE_PACK_SUCCESS",
};

export const vehicleBrand = {
  GET: "GET_VEHICLE_BRAND",
};
export const vehicleType = {
  GET: "GET_VEHICLE_TYPE",
};

export const defaultLocationActionsSelectors = {
  SET_DEFAULT_LOCATION: "SET_DEFAULT_LOCATION"
};